import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Components
import MyButton from '../../utils/MyButton';

// Redux
import { connect } from 'react-redux';
import { deleteScream } from '../../redux/actions/dataActions';

// MUI stuff
import { withStyles } from '@mui/styles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

//Icons
import DeleteOutline from '@mui/icons-material/DeleteOutline';

const styles = {
    deleteButton: {
        position: 'absolute',
        top: 8,
        right: 8
    }
};

class DeleteScream extends Component {

    state = { open: false };

    handleOpen = () => this.setState({ open: true });
    handleClose = () => this.setState({ open: false });

    handleDeleteScream = () => {
        this.props.deleteScream(this.props.screamId);
        this.setState({ open: false });
    }

    render() {
        const { classes } = this.props;
        return (
            <>
                <MyButton
                    tip="Delete Scream"
                    btnClassName={classes.deleteButton}
                    onClick={this.handleOpen}>
                    <DeleteOutline color="error" />
                </MyButton>
                <Dialog
                    open={this.state.open}
                    onClose={this.handleClose}
                    fullWidth
                    maxWidth="xs">
                    <DialogTitle>Delete Scream</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Are you sure you want to permanently delete this scream? This action cannot be undone.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="primary" variant="outlined">Cancel</Button>
                        <Button onClick={this.handleDeleteScream} color="error" variant="contained">Delete</Button>
                    </DialogActions>
                </Dialog>
            </>
        )
    }
}

DeleteScream.propTypes = {
    deleteScream: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    screamId: PropTypes.string.isRequired
};

export default connect(null, { deleteScream })(withStyles(styles)(DeleteScream));
